<script setup lang="ts">
import { useKeycloak } from '@nxtpeople/nxt-vue-keycloak';
import { useRoute } from 'vue-router';

const { query } = useRoute();
const { error_code, error_title, error_message, error_navigate_text, error_navigate_path } = query;

function handleNavigate() {
   if (query.error_code === '403') {
      return useKeycloak().keycloak.logout({ redirectUri: window.location.origin });
   }
   window.location.replace(error_navigate_path as string);
}
</script>

<template>
   <div class="error-wrapper">
      <div class="error">
         <div class="error__code">{{ error_code as string }}</div>
         <h1>{{ error_title as string }}</h1>

         <p>
            {{ error_message }}
         </p>

         <button class="nxt-button nxt-button--primary" @click="handleNavigate">
            {{ error_navigate_text as string }}
         </button>
      </div>
   </div>
</template>

<style scoped lang="scss">
.error-wrapper {
   padding: 0 toRem(48);
   height: 100%;
   width: 100%;
   display: flex;

   justify-content: center;
   align-items: center;
}

.error {
   display: flex;
   flex-direction: column;
   align-items: center;
   justify-content: center;

   h1 {
      margin: unset;
      margin: toRem(12);
   }
   p {
      margin: unset;
   }
   button {
      margin: toRem(12) 0;
   }
}
.error__code {
   color: var(--nxt-main-hover);
   font-size: toRem(100);
   font-weight: 600;
   line-height: toRem(100);
}

.error__json {
   max-height: 35rem;
   overflow: auto;
   max-width: calc(100vw - 20rem);
}
</style>
